/*
 * Copyright (c) 2020 wlocalhost.org.
 * All rights reserved.
 */

import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { IMargin } from '../interfaces/interfaces';
import { IpEmailObjectStoreService } from '../services/internals/ip-email-object-store/ip-email-object-store.service';

@Component({
  selector: 'ip-margin',
  template: `
    <div class="group">
      <mat-form-field appearance="outline">
        <mat-label i18n="Margin settings|Margin Top">Margin Top</mat-label>
        <input matInput type="number" min="0" step="1" [(ngModel)]="margin.top" (input)="markForCheck()" />
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label i18n="Margin settings|Margin Bottom">Margin Bottom</mat-label>
        <input matInput type="number" min="0" step="1" [(ngModel)]="margin.bottom" (input)="markForCheck()" />
      </mat-form-field>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
      }
    `
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class MarginComponent {
  @Input() margin: IMargin;

  constructor(private emailObject: IpEmailObjectStoreService) {}

  markForCheck() {
    this.emailObject.markForCheck();
  }
}
